import { PageSection } from '@/components/common/PageSection';
import { RuledList } from '@/components/common/RuledList';
import { SectionHeading } from '@/components/common/SectionHeading';
import { Services } from '@/pages/Home/data';

const SectionId = 'services';
const TitleId = 'services-title';

export function ServicesSection() {
  return (
    <PageSection id={SectionId} titleId={TitleId}>
      <SectionHeading id={TitleId} title={Services.title} description={Services.description} />
      <RuledList items={Services.items} columns="four" />
    </PageSection>
  );
}